<template>
  <div class="floor-details-page">
    <div>
      <div class="floor-title">
        {{ options.buildingName }}
        <el-tooltip
          class="item"
          effect="dark"
          content="关闭"
          placement="top-start"
        >
          <el-button
            type="text"
            class="closeIcon"
            @click="handleCancel"
            icon="el-icon-close"
          >
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="floor-content">
      <div class="floor-info">
        <img
          @click="showViewer($event)"
          class="img"
          :src="imgPath(options)"
          alt=""
        />
        <div class="info-top">
          <div class="infoItem">
            <img src="../../../common/assets/images/人员.png" />
            <span> 楼栋管理员 ：{{ options.buildingPersonnelName }}</span>
          </div>
          <div class="infoItem">
            <img src="../../../common/assets/images/电话.png" />
            <span>管理员电话 ： {{ options.buildingPersonnelPhone }}</span>
          </div>
          <div class="infoItem">
            <img src="../../../common/assets/images/楼层.png" />
            <span>层数 ： {{ options.floorSize + "层" }}</span>
          </div>
        </div>
      </div>
      <div class="floor-layer">
        <el-button
          type="primary"
          v-for="i in options.floorInfo"
          @click="handleOpenDraw(i)"
          :key="i.buildingCode"
          >{{ i.buildingName }}</el-button
        >
      </div>
      <div class="info-bottom">
        <div class="infoItem">
          <span style="width: 35%">
            消防负责人： {{ options.firefightingNickName }}
          </span>
          <span style="width: 65%" :title="options.officePhone">
            值班座机：{{ options.officePhone }}
          </span>
        </div>
        <div class="infoItem">
          安全管理员：{{
            options.securityPersonnelList &&
            options.securityPersonnelList
              .map((el) => {
                return (
                  el.securityPersonnelName +
                  "【" +
                  el.securityPersonnelPhone +
                  "】"
                );
              })
              .join(",")
          }}
        </div>
        <div class="infoItem">
          安全管理员备用联系人：{{
            options.alternatePersonnelList &&
            options.alternatePersonnelList
              .map((el) => {
                return (
                  el.alternatePersonnelName +
                  "【" +
                  el.alternatePersonnelPhone +
                  "】"
                );
              })
              .join(",")
          }}
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { Bus } from "$utils";
export default {
  data() {
    return {
      floorDialog: false,
      options: {},
      showMap: true,
    };
  },
  mounted() {
    // console.log(this);
  },
  methods: {
    showViewer(e) {
      console.log(1);
      let src =
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src;
      this.$app.AppInstance.handleShowViewer([src]);
    },
    imgPath(item) {
      return item ? Bus.imgPath(item.fileCode) : "";
    },
    handleOpenDraw(i) {
      // console.log(this.options);
      i.parentName = this.options.buildingName;
      this.$emit("handleOpenDraw", { ...i });
    },
    handleCancel() {
      this.$emit("closeTip");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
$bgcolor: rgba(30, 40, 64, 1);
.floor-details-page {
  width: 520px;
  //   height: 380px;
  padding: 20px 30px;
  border-radius: 5px;
  font-size: 16px;
  @include set_theme_color(background-color, map-panel-content);
  // background: rgba(24, 31, 46, 0.65);
  backdrop-filter: blur(2px);
  .floor-title {
    border-left: 4px solid #407aee;
    padding-left: 10px;
    display: flex;
    justify-content: space-between;
    .closeIcon {
      font-size: 18px;
      // color: #fff !important;
      position: absolute;
      top: 8px;
      right: 8px;
      padding: 2px;
      &:hover {
        // background: $bgcolor;
        border-radius: 50%;
        -webkit-animation: rotation 5s linear infinite;
        animation: rotation 5s linear infinite;
      }
    }
  }
  .floor-content {
    // margin: 10px 0;
    padding: 16px 0 0;
    border-radius: 5px;
    color: black;
  }
  .floor-info {
    display: flex;
    align-items: center;
    img {
      cursor: pointer;
    }
  }
  .floor-layer {
    margin: 15px 0;
    .el-button {
      height: auto;
      margin: 5px;
      font-size: 14px;
    }
  }
  .info-top {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100px;
    padding: 5px 0;
    .infoItem {
      display: flex;
      font-size: 15px;
      // color: #fff;
      img {
        margin-right: 8px;
      }

      label {
        display: block;
        width: 80px;
      }
      span {
        display: block;
        // width: 50%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .info-bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .infoItem {
      margin: 8px 0;
      display: flex;
      font-size: 15px;
      // color: #fff;
      label {
        display: block;
        width: 80px;
      }
      span {
        display: block;
        // width: 50%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .img {
    height: 100px;
    width: 190px;
  }
}
@keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>